export const fileToObjectFetch =
  (contentType: string, fileName: string) =>
  async (input: RequestInfo, init?: RequestInit): Promise<Response> => {
    const fetchOptions: RequestInit = {
      ...init,
      headers: { ...(init?.headers || {}), Accept: contentType },
      credentials: 'include', // Ensure credentials are always included for authentication
    };

    const response = await fetch(input, fetchOptions);

    if (response.ok && response.status === 200) {
      const content = await response.text();
      return new Response(JSON.stringify({ content, contentType, fileName }), {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      });
    }

    return response;
  };
